define('shared/lib/kongr',['$', 'shared/lib/beam', './kongr.source'], function( $, beam, Kongr ){
    return new Kongr( $ );
} ); 

